export default "__VITE_ASSET__B3L7pNSW__"